import { Component, OnDestroy, OnInit } from '@angular/core';
import 'rxjs/add/operator/finally';
import { GlobalInfoService } from '@app/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {

  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(private gis: GlobalInfoService) { }

  ngOnInit() {
    this.gis.set({ title: 'Gestión de procesos' });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts